import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { FetchLoader } from "src/component/element/FetchLoader";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

/**
 * 認証してないユーザーはアクセスできないように制御するコンポーネント
 *
 * @example
 *   // Pageには遷移されず、ログイン画面へ
 *    <AuthGuard>
 *      <Page />
 *    </AuthGuard>
 *
 */
export const AuthGuard = ({ children }: { children: ReactNode }): any => {
  const { status } = useSession();
  const router = useRouter();
  const { error } = useGetUserSettingsQuery();
  if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error?.status === 403 &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error?.data &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (error?.data?.error.message === "不正なアクセスキーです。" ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      error?.data?.error.message ===
        "アカウントはシステムから削除されました。" ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      error?.data?.error.message === "ログインできないユーザです。")
  ) {
    signIn();
  }

  useEffect(() => {
    if (status === "unauthenticated") {
      if (router.pathname !== "/auth/signin") {
        signIn();
      }
    }
  }, [router, status]);
  if (status === "loading") {
    return (
      <>
        <FetchLoader />
      </>
    );
  }
  if (status === "authenticated") {
    return children;
  }
};
